import { type ReactNode } from 'react';

interface DirectionProviderProps {
  children: ReactNode;
}

/**
 * DirectionProvider manages document direction (LTR/RTL) based on the current language.
 * 
 * NOTE: The actual HTML attribute setting is handled by i18n initialization
 * (see src/i18n/index.ts). This provider exists for potential future use cases
 * where we might need React context for direction-related components.
 * 
 * Since i18n already handles setting html[dir] and html[lang] attributes,
 * we avoid duplicate DOM manipulation which can cause conflicts in some
 * embedded browsers (e.g., Cursor's embedded browser).
 */
export function DirectionProvider({ children }: DirectionProviderProps) {
  // NOTE: Direction is handled by i18n initialization (src/i18n/index.ts)
  // No need to duplicate DOM manipulation here
  // This provider is kept for potential future React context needs
  
  return <>{children}</>;
}
